module.exports = __webpack_public_path__ + "img/2.2.9ee23360.png";